import React from "react";

class CesiumIframe extends React.Component {
  componentDidMount() {
    window.addEventListener("message", this.handleMessage);

    // const parts = this.props.src.split("/");
    // const origin = `${parts[0]}//${parts[2]}`;
    const { tilesets, config } = this.props;

    this.iframe.onload = () => {
      this.postMessage({
        type: "addTileSet",
        url: `${tilesets.tiles}`
      });
      this.postMessage({
        type: "addTileSet",
        url: `${tilesets.buildings}`
      });
      this.postMessage(config);
      this.postMessage({
        type: "addProposals",
        proposals: this.props.proposals
      });
    };
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.bounds) {
      this.flyTo(nextProps.bounds)
    }
    return false;
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  postMessage(data) {
    if (this.iframe) {
      this.iframe.contentWindow.postMessage(data, "*");
    } else {
      console.log("bummer");
    }
  }

  handleMessage = event => {
    // wut?
  };

  flyTo(bounds) {
    this.postMessage({
      type: "flyTo",
      bounds: bounds
    });
  }

  setPosition(config) {
    // draft
    this.postMessage(config);
  }

  render() {
    const { title, ...rest } = this.props;
    return (
      <iframe
        title={title}
        {...rest}
        ref={ref => {
          this.iframe = ref;
        }}
      />
    );
  }
}

export default CesiumIframe;



// WEBPACK FOOTER //
// ./src/app/topics/CesiumIframe.js